import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewClient = (state: StoreSchema) =>
    state.newClientState.newClient
